﻿import { tabs } from './tabs.js';
function leaseTerms() {
    const tabsElem = document.getElementById('car-terms');
    const tabSelected = function (tabs, selectedTab, targetPanelId) {
        
    }
    const tabsInstance = tabsElem == undefined ? null
        : tabs(tabsElem, {
            tabSelector: '[role="tab"]',
            tabpanelSelector: '.tab-panel-terms',
            callback: tabSelected
        });

    return {
        tabs: tabsInstance,
        callback: tabSelected
    }
}
//document.addEventListener('DOMContentLoaded', init);
export { leaseTerms };